import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0042',
    ecrans: ['00-2'],
    params: [
        'id', 
        'demcleint', 
        '?aftcleint', 
        '?urgcleint', 
        '?strcleint',
        '?temcleint', 
        '?sttdatdeb', 
        '?sttdatfin', 
        '?sttqte', 
        '?actcleint', 
        '?asgcleint', 
        '?ahtcleint', 
        '?vaesttprv'
    ]
});
